
        var i18n = require('cadenza/utils/i18n/i18n');
        module.exports = (function () {
          var messages = {"de":{"title.offline":"Offline","connecting":"Verbinden…"},"en":{"title.offline":"Offline","connecting":"Connecting ..."}};
          return function () {
            return i18n.loaderI18n.apply(messages[window.Disy.language], arguments);
          };
        })();